/* src/app/projects/project-edit/default-values/project-edit-default-values.component.scss */
.project-edit-flag64 {
  margin-right: 2rem;
  margin-left: 1rem;
}
/*# sourceMappingURL=project-edit-default-values.component-TTAJY5WH.css.map */
